import React from 'react';
import { Route } from 'react-router-dom';

import * as PATH from './path';
import HeSigninPage from '../../pages/HeSigninPage';
import HeSignUpPage from '../../pages/HeSignupPage';
import HeResult from '../../domain/he/Results/HeResult';
import HeReviewEvent from '../../domain/he/Results/HeReviewEvent';
import HeRecordingBarcode from '../../domain/he/Recording/HeRecordingBarcode';
import HeRecording from '../../domain/he/Recording/HeRecording';
import HeRecordingPlayer from '../../domain/he/Recording/HeRecordingPlayer';
import HeRecordingPrivacyConsent from '../../domain/he/Recording/HeRecordingPrivacyConsent';

const HeRoutes = () => {
  return (
    <>
      <Route exact path={PATH.HE_SIGNIN} component={HeSigninPage} />
      <Route exact path={PATH.HE_SIGNUP} component={HeSignUpPage} />
      <Route exact path={`${PATH.HE_RESULTS}/:id`} component={HeResult} />
      <Route exact path={`${PATH.HE_RESULTS}/:id/list`} component={HeResult} />
      <Route exact path={PATH.HE_REVIEW_EVENT} component={HeReviewEvent} />
      <Route exact path={PATH.HE_RECORDING} component={HeRecordingBarcode} />
      <Route exact path={`${PATH.HE_RECORDING_BARCODE}/:barcodeId/privacy-consent`} component={HeRecordingPrivacyConsent} />
      <Route exact path={`${PATH.HE_RECORDING_BARCODE}/:barcodeId/list`} component={HeRecording} />
      <Route exact path={`${PATH.HE_RECORDING}/:recordingId`} component={HeRecordingPlayer} />
    </>
  );
};

export default HeRoutes;